document.querySelectorAll(".accordion-title").forEach(button => {
    button.addEventListener("click", () => {
        const accordionContent = button.nextElementSibling;

        // Toggle the current accordion without affecting others
        button.classList.toggle("active");
        accordionContent.classList.toggle("active");

        // Dynamically adjust max-height for smooth opening/closing
        if (accordionContent.classList.contains("active")) {
            accordionContent.style.maxHeight = accordionContent.scrollHeight + "px";
        } else {
            accordionContent.style.maxHeight = null;
        }
    });
});